import React from "react";
import "../TemplateDriven/dataMapTable.scss";
import Label from "../../Label/Label";

const ValidatorValueEditableCell = ({
  textValue,
  parameterIndex,
  handleBlurValue,
  onClickCellToRedirect,
  parametersData,
  mapping,
  mappingIndex,
  rowRejectionData,
  role = "validator",
}) => {
  const styleRejectedCell = (
    mapping,
    mappingIndex,
    rowRejectionData,
    parameterIndex
  ) => {
    let backgroundColor = "#FFFF";

    if (role === "validator") {
      // for resolved and vali want to see comment'
      if (
        mapping?.validatorCellRejection?.isResolved ||
        parametersData[parameterIndex]?.validatorRowRejection?.isResolved
      ) {
        backgroundColor = "#CCE5FF";
      }
      if (
        mapping?.validatorCellRejection?.isResolved &&
        parametersData[parameterIndex]?.validatorRowRejection?.isResolved
      ) {
        backgroundColor = "#CCE5FF";
      }

      if (
        mapping?.validatorCellRejection?.isRejected ||
        parametersData[parameterIndex]?.validatorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(255 137 116)";
      }
      if (
        mapping?.validatorCellRejection?.isRejected &&
        parametersData[parameterIndex]?.validatorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 97 71)";
      }

      if (parametersData[parameterIndex]?.rowValidation?.isValidated) {
        backgroundColor = "#e5ffdb";
      }
    }

    return { backgroundColor };
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div
        style={{
          ...styleRejectedCell(
            mapping,
            mappingIndex,
            rowRejectionData,
            parameterIndex
          ),
          ...{
            padding: "0px 15px 0px 5px",
          },
          // to heighlight selected  cell for re initiate vlm

          ...(mapping?.reInitiateProVlm && {
            border: "2px solid #2776d2", // Example for "selected for reprocess"
          }),
          height: "100%",
          width: "100%",
        }}
      >
        <Label text={textValue} fontSize="16px" />
      </div>
    </div>
  );
};

export default ValidatorValueEditableCell;
